import React from 'react';
import { useIntl } from 'react-intl';
import { useRouteMatch } from 'react-router-dom';
import Breadcrumbs from '../../../breadcrumbs';
import { ICustomBreadcrumb } from '../../page-header.types';
import { getFormattedPathName } from './header-breadcrumbs.utils';

interface HeaderBreadcrumbsProps {
  className?: string;
  style?: React.CSSProperties;
  breadcrumbs: { match: any; location: any; key: any; breadcrumb: any }[];
  customCrumbs?: ICustomBreadcrumb[];
}

const HeaderBreadcrumbs: React.FunctionComponent<HeaderBreadcrumbsProps> = ({
  breadcrumbs,
  className,
  style,
  customCrumbs,
}) => {
  const { formatMessage } = useIntl();
  const currentMatch = useRouteMatch();

  const mapped = React.useMemo(() => {
    if (customCrumbs) {
      return customCrumbs;
    }

    const ret = breadcrumbs.map((b) => ({
      key: b.key,
      href: b.match.url,
      label: formatMessage({
        id: `routes.${getFormattedPathName(b.match.path)}`,
      }),
    }));

    if (
      // Check if route has params url, and if has any
      currentMatch.path !== currentMatch.url &&
      Object.values(currentMatch.params).filter(Boolean).length > 0
    ) {
      ret.pop();
    }

    return ret;
  }, [breadcrumbs, currentMatch]);

  return (
    <Breadcrumbs className={className} style={style}>
      {mapped.map(({ key, href, label }) => {
        return (
          <Breadcrumbs.Item href={href} key={key}>
            {label}
          </Breadcrumbs.Item>
        );
      })}
    </Breadcrumbs>
  );
};

export default React.memo(HeaderBreadcrumbs);
